import { useState } from 'react';
import { pic } from '../data/site';
import { useSite } from '../data/SiteContext';

export default function Contact() {
  const { createInquiry, contact } = useSite();
  const [form, setForm] = useState({ name:'', email:'', phone:'', dest:'', message:'' });
  const [status, setStatus] = useState(null); // null | 'sending' | 'sent' | error string
  const set = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async () => {
    if (status === 'sending') return;
    if (!form.name.trim()) { setStatus('Please enter your name.'); return; }
    if (!form.email.trim() && !form.phone.trim()) { setStatus('Add an email or phone so we can reply.'); return; }
    setStatus('sending');
    try {
      await createInquiry({
        name: form.name.trim(), email: form.email.trim() || null, phone: form.phone.trim() || null,
        destinationText: form.dest && form.dest !== 'Which destination?' ? form.dest : null,
        message: form.message.trim() || null,
      });
      setStatus('sent');
      setForm({ name:'', email:'', phone:'', dest:'', message:'' });
    } catch (e) {
      setStatus(e.message || 'Something went wrong, please try again.');
    }
  };

  return (
    <div className="wrap" style={{ paddingTop:40, paddingBottom:72 }}>
      <div className="kicker">Say hola</div>
      <h1 className="page-h1">Let's plan your trip</h1>
      <p className="page-sub">Send us a note and we'll reply within a day, or reach us instantly on WhatsApp.</p>
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(300px,1fr))', gap:28 }}>
        <div className="card" style={{ padding:28, borderRadius:24, boxShadow:'0 14px 34px rgba(16,90,90,0.1)' }}>
          {status === 'sent' ? (
            <div style={{ padding:'28px 8px', textAlign:'center' }}>
              <div style={{ fontSize:40, marginBottom:10 }}>🌴</div>
              <div className="serif" style={{ fontSize:24, marginBottom:8 }}>Thank you — we're on it.</div>
              <div style={{ color:'#5a726f', fontSize:15, lineHeight:1.6 }}>Your inquiry is in. Our team will reply within a day.</div>
              <button className="btn btn-soft" style={{ marginTop:18 }} onClick={() => setStatus(null)}>Send another</button>
            </div>
          ) : (
          <div style={{ display:'grid', gap:14 }}>
            <input className="input" placeholder="Your name" value={form.name} onChange={set('name')} />
            <input className="input" placeholder="Email address" value={form.email} onChange={set('email')} />
            <input className="input" placeholder="Phone / WhatsApp" value={form.phone} onChange={set('phone')} />
            <select className="input" value={form.dest} onChange={set('dest')}>
              <option value="">Which destination?</option><option>Punta Cana</option><option>Havana</option><option>Cairo & Nile</option><option>Cancún</option><option>Maldives</option><option>Zanzibar</option><option>Not sure yet</option>
            </select>
            <textarea className="input" placeholder="Tell us about your dream trip…" rows={4} style={{ resize:'vertical' }} value={form.message} onChange={set('message')}></textarea>
            {status && status !== 'sending' && <div style={{ color:'#c0492f', fontSize:13.5, fontWeight:600 }}>{status}</div>}
            <button className="btn btn-teal hover-bright" style={{ padding:15, boxShadow:'0 10px 22px rgba(14,138,122,0.35)', opacity: status === 'sending' ? 0.7 : 1 }} onClick={submit}>
              {status === 'sending' ? 'Sending…' : 'Send inquiry'}
            </button>
          </div>
          )}
        </div>
        <div style={{ display:'grid', gap:16, alignContent:'start' }}>
          <a href={contact.waLink} target="_blank" rel="noreferrer" style={{ padding:22, borderRadius:20, background:'linear-gradient(135deg,rgba(31,190,99,0.14),rgba(18,153,76,0.1))', border:'1px solid #f2e2d2', display:'flex', alignItems:'center', gap:16 }}>
          <div style={{ width:48, height:48, borderRadius:14, background:'linear-gradient(135deg,#1fbe63,#12994c)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800 }}>W</div>
            <div><div style={{ fontWeight:800, color:'#0c2b2f' }}>WhatsApp</div><div style={{ color:'#5a726f', fontSize:14 }}>{contact.phone} · fastest reply</div></div>
          </a>
          <a href={contact.telLink} className="card" style={{ padding:22, borderRadius:20, display:'flex', alignItems:'center', gap:16 }}>
            <div style={{ width:48, height:48, borderRadius:14, background:'linear-gradient(135deg,#26c6a3,#0e8a9c)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800 }}>☎</div>
            <div><div style={{ fontWeight:800, color:'#0c2b2f' }}>Call us</div><div style={{ color:'#5a726f', fontSize:14 }}>{contact.phone} · Mon–Sat 9–7</div></div>
          </a>
          <a href={contact.igLink} target="_blank" rel="noreferrer" style={{ padding:22, borderRadius:20, background:'linear-gradient(135deg,rgba(31,181,106,0.14),rgba(14,138,156,0.12))', border:'1px solid #f2e2d2', display:'flex', alignItems:'center', gap:16 }}>
            <div style={{ width:48, height:48, borderRadius:14, background:'linear-gradient(135deg,#26c6a3,#0e8a9c)', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontWeight:800 }}>IG</div>
            <div><div style={{ fontWeight:800, color:'#0c2b2f' }}>Instagram</div><div style={{ color:'#5a726f', fontSize:14 }}>@{contact.igHandle} · follow the journeys</div></div>
          </a>
          <div style={{ height:220, borderRadius:20, overflow:'hidden' }}><img src={pic('city,map,street', 4, 900, 600)} alt="Office location map" className="imgfill" /></div>
        </div>
      </div>
    </div>
  );
}
